export default __webpack_public_path__ + "static/2017060895195232-f0b0e397a5108195e1228dcc701feae5.png";